<div *ngIf="!!units">
	
	<p>Start out by finding your <b>storage unit</b> at our <b>self storage facility</b> in <b>{{location.name}}</b>. Select a size range from our available <b>storage units</b>, and get a quote.</p>
	<p>Our online storage space estimator seamlessly guides you to find the ideal storage size for your self storage needs.</p>

	<div class="unit-groups">
	<ng-container *ngFor="let group of unitGroups">
		<!-- Only show groups that have units or need to show "not available" message -->
		<div class="unit-group" [ngClass]="{'expanded': group.expanded, 'unavailable': !group.available}">

			<!-- Group Header -->
			<div class="group-header" #groupHeader (click)="toggleGroup(group, groupHeader)">
				<div class="group-icon" [ngClass]="{'parking-icon': group.sizerank === 'parking'}">
					<ng-container *ngIf="group.sizerank !== 'parking'">{{group.icon}}</ng-container>
					<img *ngIf="group.sizerank === 'parking'" src="/assets/googlefontcaricon.svg" alt="Parking bay">
				</div>
				<div class="group-content">
					<div class="group-title">
						<h2>{{getSizeName(group.name)}} <span class="units-word">{{getUnitsWord(group.name)}}</span></h2>
						<p>{{group.subtitle}}</p>
					</div>
					<!-- NO PRICE DISPLAY FOR VARIANT B -->
					<div class="price-section unavailable-message" *ngIf="!group.available">
						<div class="vertical-divider"></div>
						<div class="group-price">
							<span class="message-main">No {{group.sizerank === 'parking' ? 'bays' : 'units'}} available!</span>
							<span class="contact-part">Contact us on <a href="tel:0861736827" class="phone-link" (click)="$event.stopPropagation()">086 173 6827</a></span>
						</div>
					</div>
				</div>
				<div class="expand-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6 9L12 15L18 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</div>
			</div>

			<!-- Group Units - Using Original Layout -->
			<div class="group-units" *ngIf="group.expanded && group.available">
				<div class="size">
					<ng-container *ngFor="let unit of group.units">
						<div class="unit" [ngClass]="{'no-specials': unit.parking && !(unit.three_month_half_price || unit.one_month_half_price || unit.first_month_free)}">
							<div class="picture" [routerLink]="['storage-unit-' + unit.id]" (click)="quick_quote(unit, location)" [ngClass]="{show: show_unit_img.has(unit.id)}">
								<img [src]="
									unit.parking
									? (is_open_parking(unit) ? '/assets/unitthumb/parking-outdoor-new.svg' : '/assets/unitthumb/parking-covered-new.svg')
									: ('/assets/unitthumb/' + unit.dim + '.jpg')"
									onerror="this.error = null; this.src = '/assets/unitthumb/no-image.jpg'"
									>
							</div>
							<div class="description">
								<h3 class="dimensions" [routerLink]="['storage-unit-' + unit.id]" (click)="quick_quote(unit, location)">{{unit.dim}}: <span class="not-bold">{{unit.area|number:'1.0-2'}}m²</span></h3>
								<p *ngIf="!unit.parking" class="view-image" (click)="show_unit_img.has(unit.id) ? show_unit_img.delete(unit.id) : show_unit_img.add(unit.id)">
									{{show_unit_img.has(unit.id) ? 'Hide' : 'View'}}</p>
								<p class="header" [routerLink]="['storage-unit-' + unit.id]" (click)="quick_quote(unit, location)">{{unit.area|number:'1.0-2'}}m², {{unit.desc}}</p>
								<p class="space-estimate" [routerLink]="['storage-unit-' + unit.id]" (click)="quick_quote(unit, location)" *ngIf="!unit.parking && !!get_estimate(unit)">{{get_estimate(unit)}}</p>
							</div>
							<div class="transport" [routerLink]="['storage-unit-' + unit.id]" (click)="quick_quote(unit, location)">
								<ng-container *ngIf="unit.truck">
									<div><img [src]="'/assets/iconTruckGreen.svg'">{{'&emsp;'}}<img [src]="'/assets/iconTrailerGreen.svg'"></div>
									<p>Truck or trailer available</p>
								</ng-container>
								<ng-container *ngIf="unit.trailer && !unit.truck">
									<img [src]="'/assets/iconTrailerGreen.svg'">
									<p>Trailer available</p>
								</ng-container>
								<ng-container *ngIf="unit.parking">
									<img [src]="unit.parking ? (is_open_parking(unit) ? '/assets/unitthumb/parking-outdoor-new.svg' : '/assets/unitthumb/parking-covered-new.svg') : ''" class="parking-mobile-icon">
								</ng-container>
							</div>
							<div class="quote" [routerLink]="['storage-unit-' + unit.id]" (click)="quick_quote(unit, location)">
								<ng-container *ngIf="unit.on_sale">
									<p class="one-day-only">One day <b>only</b></p>
								</ng-container>
								<ng-container *ngIf="!unit.on_sale">
									<p *ngIf="unit.few_left && !unit.one_month_half_price && !unit.three_month_half_price && !unit.first_month_free">Few {{unit.parking ? 'bays' : 'units'}} <b>left</b></p>
									<div *ngIf="unit.three_month_half_price">
										<img [src]="'/assets/50-off-first-3-months-inv.svg'" alt="50% off your first 3 months">
									</div>
									<div *ngIf="unit.one_month_half_price">
										<img [src]="'/assets/50-off-first-month-inv.svg'" alt="50% off your first month">
									</div>
									<div *ngIf="unit.first_month_free">
										<img [src]="'/assets/one-month-free-inv.svg'" alt="First month FREE">
									</div>
								</ng-container>
								<a class="button" [routerLink]="['storage-unit-' + unit.id]" (click)="quick_quote(unit, location)">Quick quote</a>
							</div>
							<a class="button" [routerLink]="['storage-unit-' + unit.id]" (click)="quick_quote(unit, location)">Quick quote</a>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</ng-container>
	</div>
</div>